export default function goToPage(link: string): void {
  window.open(link)
}
